import Section from 'app/frontend/base/components/Section'
import { useTeam } from 'app/frontend/base/config/context/team'
import PersonalOverview from './components/PersonalOverview'
import {
  usePageInfo,
  useTeamDroptimizerConfigurations,
} from 'app/frontend/base/config/queries'
import { Route, Routes } from 'react-router-dom'
import { useState } from 'react'
import Difficulty from 'app/frontend/types/custom/Difficulty'
import { LootContext } from './context'
import TeamOverview from './components/TeamOverview'
import LootHistoryOverview from './components/LootHistoryOverview'
import TierPrioritiesOverview from './components/TierPrioritiesOverview'
import TrinketPrioritiesOverview from './components/TrinketPrioritiesOverview'

const TeamLootRoutes = ({
  droptimizerConfigurations,
}: {
  droptimizerConfigurations: wowaudit.DroptimizerConfiguration[]
}) => {
  const {
    data: { currentSeason, user },
  } = usePageInfo()
  const { team } = useTeam()

  const [difficulty, setDifficulty] = useState<Difficulty>(
    team.settings.wishlistDifficulties.value.find(
      (difficulty) => difficulty === localStorage.getItem('wishlistDifficulty'),
    ) || team.settings.wishlistDifficulties.value[0],
  )
  const [selectedSeason, setSelectedSeason] = useState(currentSeason)
  const [configuration, setConfiguration] = useState(
    droptimizerConfigurations.find(
      (configuration) =>
        configuration.id.toString() ===
        localStorage.getItem('wishlistConfigurationId'),
    ) || droptimizerConfigurations[0],
  )
  const [valueDisplay, setValueDisplay] = useState(
    localStorage.getItem('wishlistValueDisplay') || 'percentage',
  )

  return (
    <LootContext.Provider
      value={{
        difficulty,
        setDifficulty: (value) => {
          setDifficulty(value)
          localStorage.setItem('wishlistDifficulty', value)
        },
        selectedSeason,
        setSelectedSeason: (value) => {
          setSelectedSeason(value)
          localStorage.setItem('wishlistSeasonId', value.id.toString())
        },
        configuration,
        setConfiguration: (value) => {
          setConfiguration(value)
          localStorage.setItem('wishlistConfigurationId', value.id.toString())
        },
        droptimizerConfigurations,
        valueDisplay,
        setValueDisplay: (value) => {
          setValueDisplay(value)
          localStorage.setItem('wishlistValueDisplay', value)
        },
      }}
    >
      <Routes>
        <Route path='/overview' element={<TeamOverview />} />
        <Route path='/tier-status' element={<TierPrioritiesOverview />} />
        <Route path='/trinket-status' element={<TrinketPrioritiesOverview />} />
        <Route path='/characters' element={<PersonalOverview />} />
        <Route path='/characters/:characterId' element={<PersonalOverview />} />
        <Route path='/history' element={<LootHistoryOverview />} />
        <Route
          path='/'
          element={
            user && team.members?.length ? (
              <PersonalOverview />
            ) : (
              <TeamOverview />
            )
          }
        />
      </Routes>
    </LootContext.Provider>
  )
}

const TeamLoot = () => {
  const { team, guild } = useTeam()

  const {
    data: droptimizerConfigurations,
    isPending: loadingDroptimizerConfigurations,
  } = useTeamDroptimizerConfigurations(team.id)

  if (loadingDroptimizerConfigurations) return null

  return (
    <Section title={`Loot | ${team.name} | ${guild.name}`}>
      <TeamLootRoutes
        key={team.id}
        droptimizerConfigurations={droptimizerConfigurations ?? []}
      />
    </Section>
  )
}

export default TeamLoot
